module.exports = __webpack_public_path__ + "static/Falabella_sales-eed30b10e905ab37f33d81f2b5744089.png";